import type { BoardSnapshot, Meld, Tile } from './types.ts';

/** 將 tile 陣列轉為 id 排序後的字串，便於 multiset 比對。 */
function tileIdsSorted(tiles: readonly Tile[]): string[] {
  return tiles.map((t) => t.id).sort();
}

/** 比較兩個 Tile id multiset 是否相等。 */
export function multisetEqual(a: readonly Tile[], b: readonly Tile[]): boolean {
  if (a.length !== b.length) return false;
  const sa = tileIdsSorted(a);
  const sb = tileIdsSorted(b);
  for (let i = 0; i < sa.length; i++) {
    if (sa[i] !== sb[i]) return false;
  }
  return true;
}

/** 把 board 攤平成 tile 陣列。 */
export function flattenBoard(board: readonly Meld[]): Tile[] {
  const out: Tile[] = [];
  for (const meld of board) for (const t of meld) out.push(t);
  return out;
}

/** 守恆驗證：目前 board + rack 的 tile id multiset 必須等於回合起點的 board + rack。 */
export function isConserved(current: BoardSnapshot, initial: BoardSnapshot): boolean {
  const curr = [...flattenBoard(current.board), ...current.playerRack];
  const init = [...flattenBoard(initial.board), ...initial.playerRack];
  return multisetEqual(curr, init);
}
